<div class="sc-document-editor">
  <mat-card>
    <mat-card-header>
      <mat-card-title class="f-flex f-flex-row f-flex-wrap f-flex-align-items-center">
        <h5 class=" f-flex-justify-start f-flex-align-items-center control-label"
            [ngClass]="{'mandatory': componentDefinition?.mandatory}">
          {{componentDefinition?.label}}
        </h5>
        <div class="ft-editor-tools f-flex f-flex-align-items-center">
          <mat-checkbox class="make-cur-ver f-flex f-flex-row f-flex-justify-center f-flex-align-items-center" color="primary"
                        matTooltip="Make Current Version " matTooltipPosition="above"
                        [disabled]="!isEnableShouldMakeCurrentVersion"
                        (change)="onChangeMakeCurrentVersion($event)">
                        <span>Make Current Version</span>
          </mat-checkbox>
          <mat-checkbox class="f-flex f-flex-row f-flex-justify-center f-flex-align-items-center" color="primary"
                        matTooltip="Auto Save"
                        matTooltipPosition="above" [disabled]="disabled"
                        (change)="onChangeAutoSave()"><span> Auto Save</span>
          </mat-checkbox>
          <sc-document-downloader
            matTooltip="Download"
            matTooltipPosition="above"
            [toDownload]="textValue"
            [hidden]="!document?.documentId"></sc-document-downloader>

          <button type="button" mat-button
                  [disabled]="disabled"
                  matTooltip="Upload" matTooltipPosition="above"
                  (click)="file.click()">
            <mat-icon aria-hidden="false" aria-label="Upload">file_upload</mat-icon>
            <span> Upload</span>

            <input id="uploadFile" accept=".json" #file (change)="onFileSelect(file,file.files)" type="file"
                   style="display: none;">
          </button>

          <button type="button" mat-button
                  [disabled]="disabled"
                  matTooltip="Preview" matTooltipPosition="above"
                  (click)="preview()">
            <mat-icon aria-hidden="false" aria-label="Preview">remove_red_eye</mat-icon>
            <span> Preview</span>
          </button>
        </div>
      </mat-card-title>
      <div class="editor-error" [hidden]="!errorMessage" color="warn">
        {{errorMessage}}
      </div>
    </mat-card-header>

    <mat-card-content>
      <div class="disabled ? 'disable-element' : ''">
        <div [id]="fieldName+'wrapper'">
          <ace-editor [id]="fieldName" #editor
                      [mode]="mode"
                      [theme]="theme"
                      [options]="editorOptions"
                      [readOnly]="disabled"
                      [autoUpdateContent]="true"
                      [durationBeforeCallback]="10"
                      [basePath]="aceBasePath"
                      style="min-height: 200px; width:100%; overflow: auto;">
          </ace-editor>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
